import React, { useEffect, useState } from "react";
import axios from "axios";
import { IconButton } from "@mui/material";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import GangCoinConversionModal from "./GangCoinConversionModal";
import TableLoader from "Components/Common/Loader/TableLoader";
import ConfirmDeleteModal from "Components/Common/ConfirmModal/ConfirmDeleteModal";
import { toast, ToastContainer } from "react-toastify";

const ConversionTable = () => {
  const [conversions, setConversions] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("call-conversion");
  const [dataToEdit, setDataToEdit] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [mastiCategories, setMastiCategories] = useState([]);

  // Fetch all conversions
  const fetchCoinConversions = async () => {
    setLoading(true);
    try {
      let endPoint = "";

      if (activeTab === "call-conversion") {
        endPoint = "private-call-conversion";
      } else if (activeTab === "gang-conversion") {
        endPoint = "gang-coin-conversion";
      } else if (activeTab === "masti-conversion") {
        endPoint = "masti-coin-conversion";
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${endPoint}/get-all`
      );
      console.log("Response of fetchCoinConversions: ", res.data);
      setConversions(res.data.conversions || []);
    } catch (error) {
      console.log("Error in fetching gang coin conversion: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoinConversions();

    if (activeTab === "masti-conversion") {
      fetchMastiCategory();
    }
  }, [activeTab]);

  // Open modal for creating a new conversion
  const handleAdd = () => {
    setIsEditing(false);
    setSelectedId(null);
    setIsModalOpen(true);
  };

  // Open modal for editing a conversion
  const handleEdit = (item) => {
    setDataToEdit(item);
    setIsEditing(true);
    setSelectedId(item._id);
    setIsModalOpen(true);
  };

  // Delete conversion
  const handleDelete = async (conv) => {
    if (conv.isActive) {
      toast.error("Can't delete an active coin-conversion");
      return;
    }
    setDeleteModal(true);
    setSelectedId(conv._id);
  };

  const deleteCoinConversion = async () => {
    let endPoint = "gang-coin-conversion";
    if (activeTab === "call-conversion") {
      endPoint = "private-call-conversion";
    } else if (activeTab === "masti-conversion") {
      endPoint = "masti-coin-conversion";
    }
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/${endPoint}/delete/${selectedId}`
      );
      fetchCoinConversions();
      setSelectedId(null);
      setDeleteModal(false);
    } catch (error) {
      // console.error('Error deleting conversion:', error);
    }
  };

  const fetchMastiCategory = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/masti-categories/get-all`
      );
      console.log("response of fetchMastiCategory==========>", response.data);
      setMastiCategories(response.data.data);
    } catch (error) {
      console.log("Error in fetchMastiCategory: ", error);
    }
  };

  return (
    <div className="py-5">
      <ToastContainer />
      <div className="my-4 flex gap-4 pb-2">
        <button
          className={`rounded-md px-4 py-2 shadow-sm ${
            activeTab === "call-conversion"
              ? "bg-[#c51369] text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
          onClick={() => setActiveTab("call-conversion")}
        >
          Call Coin Conversion
        </button>
        <button
          className={`rounded-md px-4 py-2 shadow-sm ${
            activeTab === "gang-conversion"
              ? "bg-[#c51369] text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
          onClick={() => setActiveTab("gang-conversion")}
        >
          Gang Coin Conversion
        </button>
        <button
          className={`rounded-md px-4 py-2 shadow-sm ${
            activeTab === "masti-conversion"
              ? "bg-[#c51369] text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
          onClick={() => setActiveTab("masti-conversion")}
        >
          Masti Coin Conversion
        </button>
      </div>
      <div className="rounded-2xl bg-white p-5 shadow-sm">
        <div className="mb-4 flex items-center justify-end">
          <button
            type="button"
            className="flex items-center gap-2 rounded-md bg-[#c51369] px-4 py-2 text-white"
            onClick={handleAdd}
          >
            <FaPlus /> Add
          </button>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-t-2xl">
          {loading ? (
            <TableLoader columns={4} />
          ) : (
            <table className="w-full rounded-t-2xl text-left text-sm">
              <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                <tr className="text-center">
                  <th className="px-6 py-3">Sl No.</th>
                  <th className="px-6 py-3">Details</th>
                  <th className="px-6 py-3">Rate</th>
                  <th className="px-6 py-3">Active</th>
                  <th className="px-6 py-3">Actions</th>
                </tr>
              </thead>

              <tbody>
                {conversions?.length === 0 ? (
                  <tr>
                    <td></td>
                  </tr>
                ) : (
                  conversions?.map((c, index) => (
                    <tr
                      key={c._id}
                      className="group bg-white text-sm text-gray-700 transition hover:bg-pink-50"
                    >
                      {/* Index */}
                      <td className="border px-4 py-4 text-center font-medium">
                        {index + 1}
                      </td>

                      {/* Meta Info */}
                      <td className="border px-6 py-4">
                        <div className="flex flex-col gap-1">
                          <span className="font-medium capitalize">
                            Gender:{" "}
                            <span className="text-gray-900">{c.gender}</span>
                          </span>

                          {activeTab === "call-conversion" ? (
                            <span className="font-medium capitalize">
                              Call Type:{" "}
                              <span className="text-gray-900">
                                {c.callType}
                              </span>
                            </span>
                          ) : (
                            <span className="font-medium capitalize">
                              Role:{" "}
                              <span className="text-gray-900">{c.role}</span>
                            </span>
                          )}

                          {c?.category && (
                            <span className="font-medium capitalize">
                              Masti category:{" "}
                              <span className="text-gray-900">
                                {c.category?.name}
                              </span>
                            </span>
                          )}

                          <span
                            className={`inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-semibold
          ${
            c.verificationStatus === "Verified"
              ? "bg-pink-100 text-pink-700"
              : "bg-gray-100 text-gray-600"
          }
        `}
                          >
                            {c.verificationStatus === "Verified"
                              ? "❤️ Heart Verified"
                              : "Normal"}
                          </span>
                        </div>
                      </td>

                      {/* Conversion Rate */}
                      <td className="border px-6 py-4 text-center font-semibold text-gray-900">
                        {c.conversionRate}
                      </td>

                      {/* Active Status */}
                      <td className="border px-6 py-4 text-center">
                        <span
                          className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold
        ${
          c.isActive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
        }
      `}
                        >
                          {c.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>

                      {/* Actions */}
                      <td className="border px-6 py-4">
                        <div className="flex justify-center gap-2">
                          <IconButton
                            onClick={() => handleEdit(c)}
                            color="primary"
                          >
                            <FaEdit size={16} />
                          </IconButton>

                          <IconButton
                            onClick={() => handleDelete(c)}
                            color="error"
                          >
                            <FaTrash size={16} />
                          </IconButton>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>

        <GangCoinConversionModal
          open={isModalOpen}
          type={activeTab}
          onClose={() => setIsModalOpen(false)}
          initialData={isEditing ? dataToEdit : null}
          onRefresh={fetchCoinConversions}
          mastiCategories={mastiCategories}
        />

        <ConfirmDeleteModal
          open={deleteModal && selectedId}
          onClose={() => setDeleteModal(false)}
          title={`Delete Coin Conversion`}
          description={`Are you sure you want to delete this coin conversion rate?`}
          onConfirm={deleteCoinConversion}
        />
      </div>
    </div>
  );
};

export default ConversionTable;
